import K1 from'../objects/K1';import K1Wall from'../objects/K1_wall';import K2 from'../objects/K2';import Krossing from'../objects/Krossing';export default{name:'elements',computed:{configurator:function configurator(){return this.$store.state.configurator}},components:{K1:K1,K2:K2,k1wall:K1Wall,Krossing:Krossing}};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./app/components/views/Elements.vue
// module id = 284
// module chunks = 0